export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-skull-157f95d36c0eae163bb4edbd85621491.svg";